// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"153":"4c09b50b","440":"a94a5bd7","895":"a94a5bd7"}[chunkId] + ".chunk.css";
};